import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import ModalContainer from "./ModalContainer";

const Modal = props => {
  const { isOpen, ...otherProps } = props;

  if (isOpen && typeof window !== "undefined") {
    return ReactDOM.createPortal(
      <ModalContainer {...otherProps} />,
      document.querySelector(".revv-modal-holder"),
    );
  }
  return null;
};

(function () {
  if (typeof window !== "undefined" && document) {
    const modalContainer = document.createElement("div");
    modalContainer.className = "revv-modal-holder";
    if (document.querySelectorAll("body")[0]) {
      document.querySelectorAll("body")[0].appendChild(modalContainer);
    }
  }
})();

Modal.isModalOpen = ModalContainer.isModalOpen;
Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default Modal;
